import React, {Component} from 'react';
import SideMenu from './SideMenu.jsx';
import HeaderComponent from './HeaderComponent.jsx';
import FooterComponent from './FooterComponent.jsx';
import {Link, withRouter} from "react-router-dom";
import {withStyles} from "@material-ui/core/styles/index";
import Grid from "@material-ui/core/Grid";

const styles = theme => ({
	root: {
		flexGrow: 1,
		height: "100%",
		zIndex: 1,
		overflow: "auto",
		position: "relative",
		display: "flex",
	},
	body: {
		paddingTop: "64px"
	},
	content: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.default,
		padding: theme.spacing.unit * 3,
		minHeight: "calc(100% - 99px)" //99px is header + footer height
	}
});
@withRouter
@withStyles(styles, {withTheme: true})
export default class MainComponent extends Component {

	componentWillUpdate(nextProps, nextState){
		// figure out the current url
		let url = null;
		if (nextProps !== null && typeof nextProps !== 'undefined') {
			url = nextProps.location.pathname;
		} else {
			url = this.props.location.pathname;
		}

		// check if the current url is a /client page
		this.isClientPage = url.indexOf("/client") >= 0;
	/*	if (this.isClientPage) {
			document.getElementById('selfcare').style.paddingTop = "15px";
		} else {
			document.getElementById('selfcare').style.paddingTop = "0px";
		}*/
	}

	render() {
		return (
			<div className="content" id="content">
				<header className="header">
					<HeaderComponent location={this.props.location.pathname}/>
				</header>
					<div className="children" >
					<SideMenu />
					<div className="children-children">
					{this.props.children}
					</div>
				</div>
				<footer>
					<FooterComponent location={this.props.location.pathname}/>
				</footer>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/opencell/pages/MainComponent.jsx